export default "__VITE_ASSET__38409594__"